import React from 'react';
import { connect } from 'react-redux';
import { Form, Header, Message } from 'semantic-ui-react';

import { Form as FinalForm, Field } from 'react-final-form';
// @ts-ignore
import { selectResetPassword } from 'services/resetPassword/selectors';

// Global Components
// @ts-ignore
import LoadingButton from 'components/LoadingButton';

// Actions
import {
    resetPassword,
    resetPasswordResetState,
} from 'services/resetPassword/actions';
import { createStructuredSelector } from 'reselect';
import { ResetPasswordState } from 'services/resetPassword/reducer';

// @ts-ignore
import { validators, RenderField } from 'forms';
import { Link, withRouter } from 'react-router-dom';

// Validators
const { composeValidators, isRequired, isEmail } = validators;

// Constants
const NAMESPACE = 'RESET_PASSWORD_LOAD';

export interface Props {
    state: ResetPasswordState;
    requestResetPassword: Function;
    resetState: Function;
    location?: {
        state?: {
            username?: string;
        };
    };
}

export class ResetPasswordForm extends React.PureComponent<Props> {
    componentWillUnmount(): void {
        const { resetState } = this.props;

        resetState();
    }

    handleSubmit = (values: Record<string, any>): void => {
        const { requestResetPassword } = this.props;
        requestResetPassword(values.username);
    };

    render(): React.ReactElement {
        const { state, location } = this.props;
        const { error, submitted } = state;

        return (
            <FinalForm
                initialValues={{
                    username:
                        location && location.state
                            ? location.state.username
                            : '',
                }}
                onSubmit={this.handleSubmit}
                render={({ handleSubmit }): React.ReactElement => (
                    <Form onSubmit={handleSubmit}>
                        <Header as="h3">Reset your password</Header>
                        <p>
                            Please enter your email address. We will send you an
                            email to reset your password.
                        </p>
                        <Field
                            name="username"
                            component={RenderField as any}
                            label="Email"
                            type="email"
                            validate={composeValidators(isRequired, isEmail)}
                        />
                        {submitted && (
                            <Message positive>
                                We have just sent you an email to reset your
                                password.
                            </Message>
                        )}
                        {error && <Message negative>{error}</Message>}
                        <LoadingButton namespace={NAMESPACE} primary fluid>
                            Send email
                        </LoadingButton>
                        <p>
                            Go back to <Link to="/login">Login</Link>
                        </p>
                    </Form>
                )}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    state: selectResetPassword,
});

export default connect(
    mapStateToProps,
    {
        requestResetPassword: resetPassword,
        resetState: resetPasswordResetState,
    },
    // @ts-ignore
)(withRouter(ResetPasswordForm));
